module.exports = __webpack_public_path__ + "img/mail-02.f598def6.svg";